/**
 * Profile API Client
 * Endpoints for user profile information
 */

import { apiClient } from "./client";
import type { UserProfileInfo } from "./types";

/**
 * Get the current user's profile information
 * Includes user data, company info, license details, and static contacts
 */
export async function getUserProfile(): Promise<UserProfileInfo> {
  return apiClient.get<UserProfileInfo>("/api/v1/profile/me");
}
